"use client";

import type { ResolvedHeaderAction } from "@/utils/header-actions";
import type { NavigationBreakpoint } from "@/hooks/useMinWidth";
import HeaderActionItem, { type HeaderActionIcons } from "./HeaderActionItem";

/** Actions placed `mobile: "menu"`, shown inside the menu panel below `bp`. */
export default function MenuActions({
  actions,
  bp,
  icons,
  onSearch,
  onNavigate,
}: {
  actions: ResolvedHeaderAction[];
  bp: NavigationBreakpoint;
  icons?: HeaderActionIcons;
  onSearch?: () => void;
  onNavigate?: () => void;
}) {
  const menu = actions.filter((action) => action.mobile === "menu");
  if (!menu.length) return null;
  return (
    <div className="re-nav-menu-actions" data-bp={bp}>
      {menu.map((action) => (
        <HeaderActionItem
          key={action.key}
          action={action}
          placement="menu"
          icons={icons}
          onSearch={onSearch}
          onNavigate={onNavigate}
        />
      ))}
    </div>
  );
}
